import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCanUserWriteViews } from '../../utils/hooks/useCanUserWriteViews';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddViewPopoverFooter = ({
  onClick
}) => {
  const canUserWriteViews = useCanUserWriteViews();
  return canUserWriteViews ? /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    use: "link",
    "data-test-id": "create-view-button-footer",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.pinnedViews.createNewView"
    })
  }) : /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.addView.tooltips.notPermissioned"
    }),
    children: /*#__PURE__*/_jsx(Button, {
      disabled: true,
      use: "link",
      "data-test-id": "create-view-button-footer",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.pinnedViews.createNewView"
      })
    })
  });
};